import log$1 from 'loglevel';

var log = log$1.getLogger("SecurePubSub");

export { log as default };
